import React from "react";

type UpArrowIconProps = React.SVGProps<SVGSVGElement>;

export const UpArrowIcon = ({
  width = 20,
  height = 20,
  ...props
}: UpArrowIconProps) => (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M12 20V4M6 10L12 4L18 10" stroke="#79808A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    
    
  
);

export default UpArrowIcon;
